import React from 'react';
import Component from './component.js';
import { Link } from 'react-router-dom';

export default class Post extends Component {
  pathArray() {
    return this.
      props.
      location.
      pathname.
      split('/').
      filter((pathPart) => pathPart !== '');
  }

  render() {
    const Fragment = React.Fragment;
    return pug`
      .breadcrumbs
        span.breadcrumbs-triangle
        - const pathArray = this.pathArray();
        each pathPart, index in pathArray
          Fragment(key=index)
            Link.breadcrumbs-link(to='/' + pathArray.slice(0,index + 1).join('/') + (index === pathArray.length - 1 ? '' : '/'))= pathPart
            span.breadcrumbs-triangle
    `;
  }
}

